export default __webpack_public_path__ + "static/media/stack-management.da331c22.png";